import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  title: {
    id: 'commerce.credit-card-base.form.frame-breaker.title',
    defaultMessage: 'Unable to continue',
    description: 'The title in a section message for the credit card form error'
  },
  contactSupport: {
    id: 'commerce.credit-card-base.form.frame-breaker.contactSupportText',
    defaultMessage: 'Contact support',
    description: 'A section message button action for contacting support'
  },
  content: {
    id: 'commerce.credit-card-base.form.frame-breaker.content',
    defaultMessage: "We've detected an insecure environment and are not able to display the credit card form.",
    description: 'The main content in a section message for a credit card form error'
  }
});